import React, { useEffect, useState } from "react";
import "./WithdrawDetails.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import { formatISO, endOfDay } from "date-fns";
import webSocketService from "../../services/WebSocketService";
import StatisticTable from "../../components/StatisticTable/StatisticTable";
import useTableContent from "./hooks/useTableContent";
import { MoonLoader } from "react-spinners";
import { loaderOverride } from "../../utils/constants/constants";
import Footer from "../../components/Footer/Footer";
import parseDate from "../../utils/parseDate";
import WithdrawDetailsItem from "../../components/WithdrawDetailsItem/WithdrawDetailsItem";
import WithrawDetailsLegend from "../../components/WithrawDetailsLegend/WithrawDetailsLegend";

const WithdrawDetails = () => {
  const [data, setData] = useState([]);
  const [dataACH, setDataACH] = useState([]);
  const [dataWire, setDataWire] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { totalTable, USDTable, BTCTable } = useTableContent(
    data,
    dataACH,
    dataWire,
  );
  const navigate = useNavigate();
  const location = useLocation();

  const { date } = location.state || {};

  const dateSplitted = date.split("-");
  const dateObj = new Date(
    dateSplitted[0],
    +dateSplitted[1] - 1,
    dateSplitted[2],
  );

  const endOfDayObj = endOfDay(dateObj);

  const getDepositsData = async () => {
    const bodyTotal = {
      type: "withdrawals",
      from: formatISO(new Date(dateObj)).slice(0,19)+'Z',
      to: formatISO(new Date(endOfDayObj)).slice(0,19)+'Z',
      groupBy: "user",
      currencies: ["BTC", "USD"],
    };

    const depositsData = await webSocketService.sendMessage(
      "getStatistic",
      "c",
      bodyTotal,
    );

    const depositsDataACH = await webSocketService.sendMessage(
      "getStatistic",
      "c",
      { ...bodyTotal, subType: "ach" },
    );
    const depositsDataWire = await webSocketService.sendMessage(
      "getStatistic",
      "c",
      { ...bodyTotal, subType: "wire" },
    );

    if (typeof totals === "string") {
      setData([]);
    } else {
      setData(depositsData);
      setDataACH(depositsDataACH);
      setDataWire(depositsDataWire);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    getDepositsData();
  }, []);

  if (isLoading) {
    return (
      <div className="deposit-details__loader">
        <MoonLoader
          color="#7236CD"
          loading={isLoading}
          cssOverride={loaderOverride}
          size={35}
        />
      </div>
    );
  }
  return (
    <div className="wd-details__wrapper">
      <div className="wd-details__content">
        <Header withLogo navigate={navigate} />
        <div className="wd-details__top-block">
          <span className="wd-details__label">{parseDate(date)}</span>
        </div>
        <div className="wd-details__tables">
          <StatisticTable data={totalTable} />
          <StatisticTable data={USDTable} />
          <StatisticTable data={BTCTable} />
        </div>

        <div className="deposit__items-table">
          <WithrawDetailsLegend />
          {data?.grouped
            ? Object.entries(data?.grouped)?.map((el) => (
                <WithdrawDetailsItem
                  el={el}
                  key={el[0]}
                  dataACH={dataACH}
                  dataWire={dataWire}
                />
              ))
            : null}
        </div>
      </div>
      <Footer navigate={navigate} />
    </div>
  );
};

export default WithdrawDetails;
